import type { ArticleLocal, BaseOutbox } from '../outbox/base'
import { lister, modifier } from '../outbox/depot'

// Franchise en base de TVA : aucun article de la bibliothèque ne porte de TVA (voir les réglages
// entreprise). Les articles venus d'un import ou saisis avant la franchise sont corrigés d'un clic.

export const articlesAvecTva = (articles: ArticleLocal[]) => articles.filter((a) => a.tvaPercent !== 0)

/** Passe à 0 % tous les articles qui portent de la TVA ; renvoie leur nombre. */
export async function passerArticlesSansTva(base: BaseOutbox): Promise<number> {
  const aCorriger = articlesAvecTva(await lister(base, 'articles'))
  for (const a of aCorriger) await modifier(base, 'articles', a.id, () => ({ tvaPercent: 0 }))
  return aCorriger.length
}
